import React, {h} from 'preact';
import SellQuestionsModal from './SellQuestionsModal';
import './request-questions-modal.scss';

export default class BuyQuestionsModal extends SellQuestionsModal {
    state = {
        first: {},
        property_location: {},
        agent_questions: {},
        note: {}
    };

    ENDPOINT_ADDRESS = 'update-breq-thankyou-json';
    FLOW_NAME = 'BuyRequest';
    EVENT_SKIP_ANSWERS = 'BuyReceiptSkip';
    EVENT_SUBMIT_ANSWERS = 'BuyReceiptDone';

    STEPS = {
        first: {
            text:
                'Is there a specific property or neighborhood you are interested in?',
            next: 'property_location',
            onAnswer: answer => {
                if (!answer) {
                    this.setState({property_location: {}});
                }
                this.updateAnswers('first', null, answer);
            },
            type: 'boolean'
        },
        property_location: {
            text: '',
            onAnswer: answer => {
                this.updateAnswers('property_location', 'fullAddress', answer);
                if (this.state.first.value !== true) {
                    this.setState({
                        first: {
                            value: true
                        }
                    });
                }
            },
            type: 'string',
            inputName: 'fullAddress',
            placeholder: 'E.g. "5401 N. Pima Rd #100, Scottsdale, AZ 85250"'
        },
        agent_questions: {
            text:
                "Do you have any questions you'd like agents to answer in their proposal?",
            subQuestion: 'note',
            onAnswer: answer => {
                if (answer) {
                    this.setState({note: {}});
                }
                this.updateAnswers('agent_questions', null, answer);
            },
            type: 'boolean',
            suggestions: ['Yes, I do', 'No, I do not']
        },
        note: {
            text: ' ',
            suggestions: [
                'What sets you apart from other agents?',
                'How will you help me find the best home?'
            ],
            onAnswer: answer => {
                if (!!answer) {
                    this.setState({agent_questions: {value: true}});
                    this.updateAnswers(
                        'note',
                        'note',
                        'Buyer has the following question(s) for the agents: ' +
                            answer
                    );
                } else if (!!this.state.note.value) {
                    this.setState({note: {}});
                }
            },
            inputName: 'note',
            type: 'select'
        },
        also_selling: {
            text: 'Are you also planning to sell a home?',
            onAnswer: answer => {
                this.updateAnswers('also_selling', 'sellingAlso', answer);
            },
            type: 'boolean',
            subQuestion: 'none',
            suggestions: ['Yes, I am', 'No, I am not']
        }
    };
    render() {
        return super.render();
    }
}
